// ========= START: src/utils/audioManager.js (COMPLETE REPLACEMENT) =========
class AudioManager {
  constructor() {
    this.audioContext = null;
    this.sounds = {};
    this.currentBgmKey = null;
    this.bgmVolume = 0.5;
    this.sfxVolume = 0.8;
    this.isMuted = true; // MODIFICATION: Audio is now muted by default

    // A map of all audio files used in the application
    this.soundFiles = {
      // Background Music
      chatBgmMenu: '/assets/audio/chat_bgm_menu.mp3',
      gameBgmMenu: '/assets/audio/game_bgm_menu.mp3',
      bgmPlay: '/assets/audio/bgm_play.mp3',

      // Sound Effects
      sfxClick: '/assets/audio/sfx_click.mp3',
      sfxCorrect: '/assets/audio/sfx_correct.mp3',
      sfxLevelUp: '/assets/audio/sfx_level_up.mp3',
    };

    // Preload all sounds
    for (const key in this.soundFiles) {
      const audio = new Audio(`${process.env.PUBLIC_URL}${this.soundFiles[key]}`);
      if (key.startsWith('bgm')) {
        audio.loop = true;
      }
      this.sounds[key] = audio;
    }
  }

  // --- NEW: Mute Controls ---
  toggleMute() {
    this.isMuted = !this.isMuted;
    // Adjust currently playing BGM volume
    if (this.currentBgmKey && this.sounds[this.currentBgmKey]) {
      this.sounds[this.currentBgmKey].volume = this.isMuted ? 0 : this.bgmVolume;
    }
    return this.isMuted; // Return the new state for UI updates
  }

  // --- BGM Controls (Updated) ---
  playBGM(key) {
    if (this.currentBgmKey === key) {
      if (!this.sounds[key].paused) return;
    } else {
      this.stopBGM();
    }

    const bgm = this.sounds[key];
    if (bgm) {
      // MODIFICATION: Check isMuted state before setting volume
      bgm.volume = this.isMuted ? 0 : this.bgmVolume;
      bgm.play().catch(error => console.error(`Error playing BGM "${key}":`, error));
      this.currentBgmKey = key;
    }
  }

  stopBGM() {
    if (this.currentBgmKey && this.sounds[this.currentBgmKey]) {
      const currentBgm = this.sounds[this.currentBgmKey];
      currentBgm.pause();
      currentBgm.currentTime = 0;
    }
    this.currentBgmKey = null;
  }

  // --- SFX and Word Audio Controls (Updated) ---
  playSFX(key) {
    // MODIFICATION: Do not play if muted
    if (this.isMuted) return;
    
    const sfx = this.sounds[key];
    if (sfx) {
      sfx.currentTime = 0;
      sfx.volume = this.sfxVolume;
      sfx.play().catch(error => console.error(`Error playing SFX "${key}":`, error));
    }
  }

  playWordAudio(src) {
    // MODIFICATION: Do not play if muted
    if (this.isMuted) return;

    // This handles dynamically loaded word audio in the game
    const wordAudio = new Audio(src);
    wordAudio.volume = this.sfxVolume;
    wordAudio.play().catch(error => console.error('Error playing word audio:', error));
  }

  // --- Volume Settings (Updated) ---
  setBgmVolume(volume) {
    this.bgmVolume = volume;
    // MODIFICATION: Only apply volume if not muted
    if (this.currentBgmKey && this.sounds[this.currentBgmKey] && !this.isMuted) {
      this.sounds[this.currentBgmKey].volume = this.bgmVolume;
    }
  }

  setSfxVolume(volume) {
    this.sfxVolume = volume;
  }
}

const audioManager = new AudioManager();
export default audioManager;
// ========= END: src/utils/audioManager.js (COMPLETE REPLACEMENT) =========